const selectricComponent = class extends HTMLElement {
    select = this.querySelector("select");

    connectedCallback() {
        this.initSelectric();
    }

    initSelectric() {
        const el = $(this.select);

        // Store reference to the default option
        const defaultOption = this.select.querySelector('option[hidden]');

        el.selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            // Hook into the beforeOpen event to hide the default option
            onBeforeOpen: () => {
                if (defaultOption) {
                    this.querySelector('li').style.display = 'none'; // Hide default option
                }
            }
        });
    }
};

window.customElements.define("selectric-component", selectricComponent);
